import http from "../../http";

/** 本地推送模板 — /resident/api/resident/housePushTemplate */
const BASE = "/resident/api/resident/housePushTemplate";

const pushTemplate = {
  selectPage(r) {
    return http.get(`${BASE}/page`, r);
  },
  selectById(r) {
    return http.get(`${BASE}/detail`, r);
  },
  save(r) {
    return http.payload(`${BASE}/save`, r);
  },
  updateStatus(r) {
    return http.tip.post(`${BASE}/updateStatus`, r);
  },
  delete(r) {
    return http.confirm.post(`${BASE}/delete`, r);
  },
};

export default pushTemplate;
